<!-- Filtro (html:263-344) -->
<div class="pedido-itens-catalogo-filtro-bloco" *ngIf="produtoSelecionado == null && !isEditMode">
  <div class="pedido-itens-filtro-mobile-bar">
    <button class="btn btn-outline-secondary btn-sm" type="button" (click)="filtroMobileAlternado.emit()">
      {{ filtroMobileExpandido ? 'Ocultar filtros' : 'Mostrar filtros' }}
    </button>
    <small class="text-muted" *ngIf="filtrandoProduto">{{ produtosExibidos.length }} produto(s)</small>
  </div>

  <form [formGroup]="formFiltroProduto" (ngSubmit)="filtroSubmetido.emit()" class="pedido-itens-filtro"
    [ngClass]="{ 'pedido-itens-filtro-mobile-fechado': !filtroMobileExpandido }">
    <div class="pedido-itens-filtro-linha">
      <div class="pedido-itens-filtro-campo">
        <label class="text-secondary"><b>Filtrar Produto por:</b></label>
        <select class="form-control form-control-sm" formControlName="filtro"
          (change)="filtroAlterado.emit($event.target.value)">
          <option *ngFor="let opcao of filtroProdutos" [value]="opcao.valor">{{ opcao.texto }}</option>
        </select>
      </div>

      <!-- Código -->
      <div class="pedido-itens-filtro-campo" *ngIf="formFiltroProduto.controls['filtro'].value == 1">
        <label class="text-secondary"><b>Código:</b></label>
        <input class="form-control form-control-sm" type="text"
          [ngClass]="{ 'is-invalid': enviadoProduto && formFiltroProduto.controls['codigo'].errors?.required }"
          formControlName="codigo" />
        <div class="erro pt-1" *ngIf="enviadoProduto && formFiltroProduto.controls['codigo'].errors?.required">Código em branco!</div>
      </div>

      <!-- Descrição -->
      <div class="pedido-itens-filtro-campo pedido-itens-filtro-campo-lg" *ngIf="formFiltroProduto.controls['filtro'].value == 2">
        <label class="text-secondary"><b>Descrição:</b></label>
        <input class="form-control form-control-sm" type="text"
          [ngClass]="{ 'is-invalid': enviadoProduto && formFiltroProduto.controls['descricao'].errors?.required }"
          formControlName="descricao" />
        <div class="erro pt-1" *ngIf="enviadoProduto && formFiltroProduto.controls['descricao'].errors?.required">Descrição em branco!</div>
      </div>

      <!-- Marca -->
      <div class="pedido-itens-filtro-campo pedido-itens-filtro-campo-lg" *ngIf="formFiltroProduto.controls['filtro'].value == 3">
        <label class="text-secondary"><b>Marca:</b></label>
        <input class="form-control form-control-sm" type="text"
          [ngClass]="{ 'is-invalid': enviadoProduto && formFiltroProduto.controls['marca'].errors?.required }"
          formControlName="marca" />
        <div class="erro pt-1" *ngIf="enviadoProduto && formFiltroProduto.controls['marca'].errors?.required">Marca em branco!</div>
      </div>

      <!-- Referência -->
      <div class="pedido-itens-filtro-campo pedido-itens-filtro-campo-lg" *ngIf="formFiltroProduto.controls['filtro'].value == 4">
        <label class="text-secondary"><b>Referência:</b></label>
        <input class="form-control form-control-sm" type="text"
          [ngClass]="{ 'is-invalid': enviadoProduto && formFiltroProduto.controls['referencia'].errors?.required }"
          formControlName="referencia" />
        <div class="erro pt-1" *ngIf="enviadoProduto && formFiltroProduto.controls['referencia'].errors?.required">Referência em branco!</div>
      </div>

      <!-- Status -->
      <div class="pedido-itens-filtro-campo" *ngIf="formFiltroProduto.controls['filtro'].value != 0">
        <label class="text-secondary"><b>Status:</b></label>
        <select class="form-control form-control-sm" formControlName="status">
          <option *ngFor="let opcao of filtroStatus" [value]="opcao.valor">{{ opcao.texto }}</option>
        </select>
      </div>

      <div class="pedido-itens-filtro-acoes">
        <button class="btn btn-secondary btn-sm" type="submit">Filtrar</button>
        <button class="btn btn-secondary btn-sm" type="button"
          *ngIf="filtrandoProduto && produtosComErro.length == 0"
          (click)="filtroAlterado.emit(null)">Cancelar</button>
      </div>
    </div>
    <label class="pedido-itens-filtro-promocao">
      <input type="checkbox" [checked]="somentePromocoes" (change)="promocoesAlternadas.emit()" />
      Somente produtos em promoção
    </label>
  </form>
  <hr class="mt-2 mb-2" />
</div>

<!-- Campanhas (Alteração) (html:348-356) -->
<div class="d-flex justify-content-center" *ngIf="pedido != null && filtroProdutoSelecionado == '0'">
  <div class="pt-2">
    <div class="text-secondary">
      <b>Campanhas não disponíveis para alteração de pedido.</b>
    </div>
  </div>
</div>

<!-- Modo Edição: barra de navegação (html:360-371) -->
<div class="d-flex align-items-center mb-2 p-2 bg-light border rounded" *ngIf="isEditMode">
  <button class="btn btn-outline-secondary btn-sm" type="button" (click)="voltarModoEdicao.emit()">
    ← Voltar à listagem
  </button>
  <span class="ml-3 text-secondary" *ngIf="itemEmEdicao != null">
    Editando: <b>{{ itemEmEdicao.name }}</b>
  </span>
</div>

<!-- Campanhas/Produtos: lista virtualizada de cards (html:376-559).
     Gate restaurado (fix round 1): a lista só é exibida quando `exibirLista` for true,
     espelhando o `@if (filtrandoProduto || saldoGeradoErro)` que envolvia todo o
     `cdk-virtual-scroll-viewport` no html original antes da Task 5. -->
<cdk-virtual-scroll-viewport *ngIf="exibirLista" [itemSize]="itemSize" [style.height.px]="viewportHeight"
  style="display: block; overflow-y: auto;" class="pedido-itens-catalogo-viewport">
  <div *cdkVirtualFor="let produto of produtosExibidos; let i = index; trackBy: trackByProdutoId; templateCacheSize: 0"
    class="pedido-itens-card"
    [class.pedido-itens-card-selecionado]="produto.expandido || produto.id === produtoSelecionadoId"
    [class.pedido-itens-card-edicao]="produto['emEdicao']">

    <!-- Campanha (html:390-456) -->
    <ng-container *ngIf="produto.categoria == campanhas">
      <div class="pedido-itens-card-campanha">
        <div class="pedido-itens-card-info">
          <span class="badge badge-warning">{{ produto.grupo_estoque }}</span>
          <div class="pedido-itens-card-nome"><b>{{ produto.name }}</b></div>
        </div>

        <div class="pedido-itens-card-campanha-valores" *ngIf="produto.qtde > 0">
          <div class="pedido-itens-mini-campo">
            <span class="label">Qtde</span>
            <b>{{ produto.qtde }}</b>
          </div>
          <div class="pedido-itens-mini-campo text-right">
            <span class="label">Unitário: R$</span>
            <b *ngIf="produto.grupo_estoque == combo">{{ produto.valor_total_produtos_vinculados | currency: 'BRL' }}</b>
            <b *ngIf="produto.grupo_estoque != combo">{{ produto.valor_fator_financeiro_produto | currency: 'BRL' }}</b>
          </div>
          <div class="pedido-itens-mini-campo text-right" *ngIf="configuracao != null && configuracao.flag_exibir_imposto_produto">
            <span class="label">C/ Imposto: R$</span>
            <b>{{ produto.valor_imposto_produto | currency: 'BRL' }}</b>
          </div>
          <div class="pedido-itens-mini-campo text-right">
            <span class="label">Sub-Total: R$</span>
            <b>{{ produto.valor_imposto_total_final | currency: 'BRL' }}</b>
          </div>
        </div>

        <div class="pedido-itens-aviso-pendencia"
          *ngIf="usaPendencia && produto.qtde > 0 && produto.estoque != null && produto.qtde > produto.estoque && !(produto.produtos_vinculados?.length > 0)"
          [title]="'Qtd. acima do estoque. Será criado pedido pendência para ' + (produto.qtde - produto.estoque) + ' un.'">
          &#9888; Pendência: {{ produto.qtde - produto.estoque }} un.
        </div>

        <div class="pedido-itens-card-acoes">
          <button class="btn btn-success btn-sm" type="button" *ngIf="produto.qtde == null"
            (click)="campanhaAdicionarOuAlterar.emit({ content: modalCampanha, id_campanha: produto.id_campanha })">Adicionar</button>
          <button class="btn btn-success btn-sm" type="button" *ngIf="produto.qtde > 0"
            (click)="campanhaAdicionarOuAlterar.emit({ content: modalCampanha, id_campanha: produto.id_campanha })">Alterar</button>
          <button class="btn btn-danger btn-sm" type="button" *ngIf="produto.qtde > 0"
            (click)="campanhaExcluida.emit(produto.id_campanha)">Excluir</button>
        </div>
      </div>
    </ng-container>

    <!-- Produtos (html:458-559) -->
    <ng-container *ngIf="produto.categoria != campanhas">
      <div class="pedido-itens-card-produto">
        <div class="pedido-itens-card-cabecalho">
          <div class="pedido-itens-card-nome-linha">
            <span class="pedido-itens-tag-promocao" *ngIf="+produto.promocao === 1">Promoção</span>
            <button class="btn btn-link pedido-itens-card-nome-btn" type="button"
              (click)="produtoClicado.emit({ id_produto: produto.id, index: i })">{{ produto.name }}</button>
            <span class="ml-2 atencao" *ngIf="produto.estoque_lote == 0">&nbsp;</span>

            <span class="badge badge-warning ml-2 p-1 pedido-itens-aviso-pendencia-badge"
              *ngIf="usaPendencia && produto.qtde > 0 && produto.estoque != null && produto.qtde > produto.estoque && !(produto.produtos_vinculados?.length > 0)"
              [title]="'Qtd. acima do estoque. Será criado pedido pendência para ' + (produto.qtde - produto.estoque) + ' un.'">
              &#9888; Pendência: {{ produto.qtde - produto.estoque }} un.
            </span>
          </div>
          <div class="text-secondary pedido-itens-card-unidade" title="Unidade"><b>{{ produto.unit || '—' }}</b></div>
          <div class="text-secondary pedido-itens-card-grupo"><b>{{ produto.grupo_estoque }}</b></div>
        </div>

        <div class="pedido-itens-card-badges">
          <span class="badge badge-info ml-2 p-2" *ngIf="ehPrecoTravado(produto)">
            {{ obterLabelPrecoTravado(produto) }}
            <button type="button" class="pedido-itens-badge-close" (click)="$event.stopPropagation(); travaRemovida.emit(produto.id)">✕</button>
          </span>
          <span class="badge badge-secondary ml-2 p-1" *ngIf="produto['ignorar_pontuacao_por_tabela']"
            title="Tabela especial: fator financeiro não aplicado no preço nem na pontuação">
            Sem fator fin. (tabela)
          </span>
        </div>

        <div class="pedido-itens-card-preco-resumo" *ngIf="!produto.expandido">
            <span class="badge badge-light border ml-2 pedido-itens-badge-estoque" *ngIf="!produto.expandido"
              title="Quantidade em estoque">
              Estoque:&nbsp;<b [ngClass]="{ 'text-danger': (produto.qtde_lote > 0 && produto.id_lote != null ? (produto.estoque_lote != null ? produto.estoque_lote : 0) : (produto.estoque != null ? produto.estoque : 0)) == 0 }">
                {{ produto.qtde_lote > 0 && produto.id_lote != null ? (produto.estoque_lote != null ? produto.estoque_lote : 0) : (produto.estoque != null ? produto.estoque : '—') }}
              </b>
            </span>
          <div class="pedido-itens-mini-campo" *ngIf="produto.qtde_lote == 0">
            <span class="label">
              <ng-container *ngIf="configuracao != null && !configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro && prazoPagamentoSelecionado != null">S/ Fator: R$</ng-container>
              <ng-container *ngIf="configuracao != null && !configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro && prazoPagamentoSelecionado == null">Tabela: R$</ng-container>
              <ng-container *ngIf="configuracao != null && !configuracao.utiliza_fator_financeiro">Tabela: R$</ng-container>
            </span>
            <b>{{ formatarValoresQuatroCasasDecimais(produto.valor_tabela != null && produto.valor_tabela > 0 ? produto.valor_tabela : produto.price) }}</b>
          </div>
          <div class="pedido-itens-mini-campo"
            *ngIf="produto.qtde_lote == 0 && configuracao != null && !configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro && prazoPagamentoSelecionado != null">
            <span class="label">C/ Fator: R$</span>
            <b>{{ formatarValoresQuatroCasasDecimais(produto.valor_fator_financeiro_tabela) }}</b>
          </div>
          <div class="pedido-itens-mini-campo" *ngIf="produto.qtde_lote > 0 && produto.id_lote != null">
            <span class="label">Tabela: R$</span>
            <b>{{ produto.preco_lote | currency: 'BRL' }}</b>
          </div>
          <div class="pedido-itens-mini-campo"
            *ngIf="exibirPontuacao && produto.pontuacao != null && produto.pontuacao > 0 && produto.pontuacao_calculada != null && produto.pontuacao_calculada > 0">
            <span class="label">Pontuação:</span>
            <b>{{ produto.pontuacao_calculada | number: '1.2-2' }}</b>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</cdk-virtual-scroll-viewport>
